import styled from 'styled-components';
import Tabs from '../../../core/components/Tabs';
export const InputAutocompleteTabs = styled(Tabs) `
  button {
    text-transform: capitalize;
  }
`;
//# sourceMappingURL=styles.js.map